// extracted by mini-css-extract-plugin
export default {"error":"errorFailed_error__Nw6Gy","errorIcon":"errorFailed_errorIcon__ORIkt"};